import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import ShopifyWork from "@/components/site/ShopifyWork";
import Tech from "@/components/site/Tech";
import Manifesto from "@/components/site/Manifesto";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";

export default function HomePage() {
    return (
        <div data-testid="home-page">
            <Hero />
            <Marquee />
            <Services />
            <ShopifyWork />
            <Tech />
            <Manifesto />
            <Testimonials />
            <FinalCTA />
        </div>
    );
}
